import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ProductPage"] */ "/vercel/path1/src/components/product-details/ProductPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["posthogBrowser","captureException"] */ "/vercel/path1/src/integrations/posthog/client-browser.ts");
